var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{attrs:{"size":"medium","label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"名称："}},[_c('el-input',{attrs:{"placeholder":"请输入内容"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }